import {observable, action, computed} from 'mobx';

import {
    getAllAvailableStationIndexes,
    getDistinctRatingTableListingsByStationIndex,
    getDistinctTypeNumbersByStationIndex,
    postRatingTable,
    updateRatingTableListing,
    deleteRatingTableListing
} from '../actions/winhydro_api';

import {station} from '../actions/api';

class HydrologyStore {
    @observable ratingTables = [];
    // @observable tssStations = [];
    @observable stations = [];
    @observable selectedStation = '';
    @observable typeNumbers = [];
    @observable selectedTypeNo = '';
    @observable isLoading = false;
    @observable isSaving = false;

    constructor(stationStore) {
        this.stationStore = stationStore;
    }

    @computed get tssStations() {
        return this.stationStore.items;
    }

    @action fetchStations = () => {
        return getAllAvailableStationIndexes().then(res => {
            if(!res.errors) {
                this.stations = res;
                // this.fetchTssStations();

                return res;
            } else {
                this.stations = [];

                alert("Request Failed");

                return [];
            }
        });
    }

    // @action fetchTssStations = () => {
    //     return station.fetchAll().then(res => {
    //         if(!res.errors) {
    //             this.tssStations = res;

    //             return res;
    //         } else {
    //             this.tssStations = [];

    //             alert("Request Failed");

    //             return [];
    //         }
    //     });
    // }

    @action fetchUniqueTypeNumbersByStationIndex = () => {
        if(this.selectedStation !== '') {
            return getDistinctTypeNumbersByStationIndex(this.selectedStation).then((res) => {
                if(!res.error) {
                    this.typeNumbers = res;

                    return res;
                } else {
                    this.typeNumbers = [];

                    alert('Request Failed');

                    return [];
                }
            });
        }
    }

    @action fetchRatingTableListingsByStationIndex = () => {
        if(this.selectedStation !== '') {
            return getDistinctRatingTableListingsByStationIndex(this.selectedStation).then(res => {
                if(!res.error) {
                    this.ratingTables = res;

                    return res;
                } else {
                    this.ratingTables = [];

                    alert("Request Failed");

                    return [];
                }
            });
        }
    }

    @action setSelectedStation = (selectedStation) => {
        this.selectedStation = selectedStation;
    }

    @action setSelectedTypeNo = (selectedTypeNo) => {
        this.selectedTypeNo = selectedTypeNo;
    }

    @action setRatingTables = (ratingTables) => {
        this.ratingTables = ratingTables;
    }

    @computed get associatedTSSStation() {
        return this.selectedStation !== '' && this.tssStations.find(station => !!(station.meta_data && station.meta_data.find(meta_data => meta_data.name === 'Station Index' && meta_data.value == this.selectedStation)))
    }

    insertRatingTable(data) {
        return postRatingTable(data).then(res => {
            console.log(res);

            if(!res.error) {
                this.addRatingTable(res);
            } else {
                alert("Request Failed");
            }

            return res;
        });
    }

    @action
    updateRatingTable(data) {
        return updateRatingTableListing(data).then(res => {
            console.log(res);

            if(!res.erorr) {
                this.ratingTables = this.ratingTables.map(item => {
                    if (item.id === data.id) {
                        return res;
                    } else {
                        return item;
                    }
                });
            } else {
                alert("Request Failed");
            }

            return res;
        });
    }

    @action
    deleteRatingTable(id) {
        return deleteRatingTableListing(id).then(res => {
            console.log(res);

            if(!res.error) {
                this.ratingTables = this.ratingTables.filter(item => +item.id !== +id);
            } else {
                alert("Request Failed");
            }

            return res;
        });
    }

    @action addRatingTable(ratingTable) {
        this.ratingTables = [...this.ratingTables, ratingTable];
    }

    findRatingTableById(id) {
        return this.ratingTables.find(i => +i.id === +id);
    }
}

export default HydrologyStore;



// WEBPACK FOOTER //
// ./src/stores/HydrologyStore.js